export const PROJECT_STATUS = {
  NO_STATUS: 'No_Status',
  IN_PROCESS: 'In_Process',
  COMPLETED: 'Completed',
  REVIEWED: 'Reviewed',
  EDITED_AFTER_REVIEW: 'Edited_After_Review',
  LOCKED: 'Locked',
};

export const PROJECT_STATUS_ARRAY = Object.values(PROJECT_STATUS).sort();

export const PROJECTS_TABLE_HEADERS = {
  NAME: "name",
  STATUS: "status", 
  TYPE: "type", 
  LEADER: "leader",
  YEAR: "year",
  DUE_DATE: "due_date",
  PATH: "path",
  DISK_USAGE: "disk_usage"
};

export const CLIENTS_TABLE_HEADERS = {
  NAME: "name",
  ALL_USERS: "allUsers",
  ACTIVE_USERS: "activeUsers",
  USERS_WITH_AT_LEAST_ONE_COMMIT: "usersWithAtLeastOneCommit",
  DATETIME_OF_FIRST_COMMIT: "datetimeOfFirstCommit",
  DATETIME_OF_SECOND_COMMIT: "datetimeOfSecondCommit",
  DATETIME_OF_LAST_COMMIT: "datetimeOfLastCommit",
  AVERAGE_COMMITS_PER_USER: "averageCommitsPerUser",
  AVERAGE_COMMITS_PER_MONTH: "averageCommitsPerMonth",
  NUMBER_OF_COMMITS: "numberOfCommits",
  NUMBER_OF_PROJECTS: "numberOfProjects",
  WORK_PAPERS_DISK_USAGE: "workPapersDiskUsage",
  SVN_FOLDER_DISK_USAGE: "svnFolderDiskUsage",
  SVN_DB_FOLDER_DISK_USAGE: "svnDbFolderDiskUsage",
  REPOSITORY_DISK_USAGE: "repositoryDiskUsage",
  HTML_DISK_USAGE: "htmlDiskUsage",
};

export const CURRENT_STEPS_TABLE_HEADERS = {
  PROJECT: "project",
  INSTRUCTION_NOTES: "instruction_notes",
  IN_PROCESS: "in_process",
  COMPLETED: "completed",
  REVIEWED: "reviewed",
  LOCKED: "locked",
  ALL: "all",
  PROGRESS: "progress",
};

export const RIGHTS = {
  READ: "read",
  LOCK: "lock",
  REVIEW: "review",
  WRITE: "write",
  GRANT_ACCESS: "grant_access"
};

export const STATUSES = {
  NO_STATUS: "NO_STATUS",
  IN_PROCESS: "In_Process",
  EDITED_AFTER_REVIEW: "Edited_After_Review",
  COMPLETED: "Completed",
  REVIEWED: "Reviewed",
  LOCKED: "Locked",
};

export const JSON_KEYS = {
  PATH: "path",
};

export const MULTISELECT_COLUMNS = ["leader", "type", "year"];

export const PROJECTS_TABLE_HEADERS_ARRAY = Object.values(PROJECTS_TABLE_HEADERS);

export  const CLIENTS_TABLE_HEADERS_ARRAY = Object.values(CLIENTS_TABLE_HEADERS);

export const CURRENT_STEPS_TABLE_HEADERS_ARRAY = Object.values(CURRENT_STEPS_TABLE_HEADERS);
